import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { MapPinIcon, CalendarIcon, UserIcon, BuildingIcon, EditIcon, SaveIcon, XIcon, ClockIcon } from 'lucide-react';
export function BasicInfoTab({
  contact,
  isEditing,
  setIsEditing,
  onUpdate
}) {
  const [editingSection, setEditingSection] = useState(null); // 'personal', 'contact', or 'address'
  const [formData, setFormData] = useState({
    firstName: contact.firstName || '',
    lastName: contact.lastName || '',
    company: contact.company || '',
    position: contact.position || '',
    email: contact.email || '',
    phone: contact.phone || '',
    dob: contact.dob || '',
    address: {
      street: contact.address?.street || '',
      city: contact.address?.city || '',
      state: contact.address?.state || '',
      zip: contact.address?.zip || '',
      country: contact.address?.country || ''
    }
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData({
        ...formData,
        [parent]: {
          ...formData[parent],
          [child]: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleEdit = section => {
    setEditingSection(section);
    setIsEditing(true);
  };
  const handleSave = () => {
    // Create an object with only the fields from the section being edited
    let updatedData = {};
    if (editingSection === 'personal') {
      updatedData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        company: formData.company,
        position: formData.position,
        dob: formData.dob
      };
    } else if (editingSection === 'contact') {
      updatedData = {
        email: formData.email,
        phone: formData.phone
      };
    } else if (editingSection === 'address') {
      updatedData = {
        address: formData.address
      };
    }
    onUpdate(updatedData);
    setEditingSection(null);
    setIsEditing(false);
  };
  const handleCancel = () => {
    // Reset form data to original contact values
    setFormData({
      firstName: contact.firstName || '',
      lastName: contact.lastName || '',
      company: contact.company || '',
      position: contact.position || '',
      email: contact.email || '',
      phone: contact.phone || '',
      dob: contact.dob || '',
      address: {
        street: contact.address?.street || '',
        city: contact.address?.city || '',
        state: contact.address?.state || '',
        zip: contact.address?.zip || '',
        country: contact.address?.country || ''
      }
    });
    setEditingSection(null);
    setIsEditing(false);
  };
  const formatDate = dateString => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date);
  };
  return <div data-id="element-105">
      {/* Personal Information Section */}
      <Card title="Personal Information" actions={editingSection === 'personal' ? <div className="flex gap-2" data-id="element-107">
              <button onClick={handleSave} className="flex items-center gap-1 px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm" data-id="element-108">
                <SaveIcon className="w-3 h-3" data-id="element-109" />
                <span data-id="element-110">Save</span>
              </button>
              <button onClick={handleCancel} className="flex items-center gap-1 px-3 py-1 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors text-sm" data-id="element-111">
                <XIcon className="w-3 h-3" data-id="element-112" />
                <span data-id="element-113">Cancel</span>
              </button>
            </div> : <button onClick={() => handleEdit('personal')} className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm" data-id="element-114">
              <EditIcon className="w-3 h-3" data-id="element-115" />
              <span data-id="element-116">Edit</span>
            </button>} data-id="element-106">
        {editingSection === 'personal' ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-117">
            {contact.type === 'person' && <>
                <div data-id="element-118">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-119">
                    First Name
                  </label>
                  <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-120" />
                </div>
                <div data-id="element-121">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-122">
                    Last Name
                  </label>
                  <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-123" />
                </div>
              </>}
            <div data-id="element-124">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-125">
                Company
              </label>
              <input type="text" name="company" value={formData.company} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-126" />
            </div>
            {contact.type === 'person' && <div data-id="element-127">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-128">
                  Position
                </label>
                <input type="text" name="position" value={formData.position} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-129" />
              </div>}
            {contact.type === 'person' && <div data-id="element-130">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-131">
                  Date of Birth
                </label>
                <input type="date" name="dob" value={formData.dob} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-132" />
              </div>}
          </div> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-133">
            {contact.type === 'person' ? <div className="flex items-start gap-3" data-id="element-134">
                <UserIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-135" />
                <div data-id="element-136">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-137">
                    Full Name
                  </h4>
                  <p className="text-gray-800" data-id="element-138">
                    {contact.firstName} {contact.lastName}
                  </p>
                </div>
              </div> : <div className="flex items-start gap-3" data-id="element-139">
                <BuildingIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-140" />
                <div data-id="element-141">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-142">
                    Organization Name
                  </h4>
                  <p className="text-gray-800" data-id="element-143">{contact.company}</p>
                </div>
              </div>}
            <div className="flex items-start gap-3" data-id="element-144">
              <BuildingIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-145" />
              <div data-id="element-146">
                <h4 className="text-sm font-medium text-gray-500" data-id="element-147">Company</h4>
                <p className="text-gray-800" data-id="element-148">{contact.company}</p>
              </div>
            </div>
            {contact.type === 'person' && <div className="flex items-start gap-3" data-id="element-149">
                <UserIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-150" />
                <div data-id="element-151">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-152">
                    Position
                  </h4>
                  <p className="text-gray-800" data-id="element-153">{contact.position}</p>
                </div>
              </div>}
            {contact.type === 'person' && <div className="flex items-start gap-3" data-id="element-154">
                <CalendarIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-155" />
                <div data-id="element-156">
                  <h4 className="text-sm font-medium text-gray-500" data-id="element-157">
                    Date of Birth
                  </h4>
                  <p className="text-gray-800" data-id="element-158">{formatDate(contact.dob)}</p>
                </div>
              </div>}
          </div>}
      </Card>
      {/* Contact Information Section */}
      <Card title="Contact Information" actions={editingSection === 'contact' ? <div className="flex gap-2" data-id="element-160">
              <button onClick={handleSave} className="flex items-center gap-1 px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm" data-id="element-161">
                <SaveIcon className="w-3 h-3" data-id="element-162" />
                <span data-id="element-163">Save</span>
              </button>
              <button onClick={handleCancel} className="flex items-center gap-1 px-3 py-1 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors text-sm" data-id="element-164">
                <XIcon className="w-3 h-3" data-id="element-165" />
                <span data-id="element-166">Cancel</span>
              </button>
            </div> : <button onClick={() => handleEdit('contact')} className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm" data-id="element-167">
              <EditIcon className="w-3 h-3" data-id="element-168" />
              <span data-id="element-169">Edit</span>
            </button>} data-id="element-159">
        {editingSection === 'contact' ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-170">
            <div data-id="element-171">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-172">
                Email
              </label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-173" />
            </div>
            <div data-id="element-174">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-175">
                Phone
              </label>
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-176" />
            </div>
          </div> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-177">
            <div data-id="element-178">
              <h4 className="text-sm font-medium text-gray-500" data-id="element-179">Email</h4>
              <p className="text-gray-800" data-id="element-180">{contact.email}</p>
            </div>
            <div data-id="element-181">
              <h4 className="text-sm font-medium text-gray-500" data-id="element-182">Phone</h4>
              <p className="text-gray-800" data-id="element-183">{contact.phone}</p>
            </div>
          </div>}
      </Card>
      {/* Address Section */}
      <Card title="Address" actions={editingSection === 'address' ? <div className="flex gap-2" data-id="element-185">
              <button onClick={handleSave} className="flex items-center gap-1 px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm" data-id="element-186">
                <SaveIcon className="w-3 h-3" data-id="element-187" />
                <span data-id="element-188">Save</span>
              </button>
              <button onClick={handleCancel} className="flex items-center gap-1 px-3 py-1 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors text-sm" data-id="element-189">
                <XIcon className="w-3 h-3" data-id="element-190" />
                <span data-id="element-191">Cancel</span>
              </button>
            </div> : <button onClick={() => handleEdit('address')} className="flex items-center gap-1 px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm" data-id="element-192">
              <EditIcon className="w-3 h-3" data-id="element-193" />
              <span data-id="element-194">Edit</span>
            </button>} data-id="element-184">
        {editingSection === 'address' ? <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-195">
            <div className="md:col-span-2" data-id="element-196">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-197">
                Street Address
              </label>
              <input type="text" name="address.street" value={formData.address.street} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-198" />
            </div>
            <div data-id="element-199">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-200">
                City
              </label>
              <input type="text" name="address.city" value={formData.address.city} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-201" />
            </div>
            <div data-id="element-202">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-203">
                State/Province
              </label>
              <input type="text" name="address.state" value={formData.address.state} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-204" />
            </div>
            <div data-id="element-205">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-206">
                Postal Code
              </label>
              <input type="text" name="address.zip" value={formData.address.zip} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-207" />
            </div>
            <div data-id="element-208">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-209">
                Country
              </label>
              <input type="text" name="address.country" value={formData.address.country} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500" data-id="element-210" />
            </div>
          </div> : <div className="flex items-start gap-3" data-id="element-211">
            <MapPinIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-212" />
            <div data-id="element-213">
              <p className="text-gray-800" data-id="element-214">{contact.address.street}</p>
              <p className="text-gray-800" data-id="element-215">
                {contact.address.city}, {contact.address.state}{' '}
                {contact.address.zip}
              </p>
              <p className="text-gray-800" data-id="element-216">{contact.address.country}</p>
            </div>
          </div>}
      </Card>
      {/* Date information rows */}
      <div className="mt-6 space-y-3" data-id="element-217">
        <div className="flex items-start gap-3" data-id="element-218">
          <CalendarIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-219" />
          <div data-id="element-220">
            <h4 className="text-sm font-medium text-gray-500" data-id="element-221">Created</h4>
            <p className="text-gray-800" data-id="element-222">{formatDate(contact.created)}</p>
          </div>
        </div>
        <div className="flex items-start gap-3" data-id="element-223">
          <ClockIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-224" />
          <div data-id="element-225">
            <h4 className="text-sm font-medium text-gray-500" data-id="element-226">
              Last Contacted
            </h4>
            <p className="text-gray-800" data-id="element-227">{formatDate(contact.lastContacted)}</p>
          </div>
        </div>
      </div>
    </div>;
}